/**
 * /importer/v1 api endpoint
 * @see https://services.vedavaapi.org:8443/api/importer/v1/docs
 */

import * as iiif from './iiif';

// eslint-disable-next-line import/prefer-default-export
export { iiif };
